<script setup lang="ts">
import { computed } from '#imports';
import { UiImage } from '../image';

const props = withDefaults(defineProps<{
  badge?: number;
  status?: boolean;
  text?: string;
  image?: string;
  active?: boolean;
}>(), {
  badge: 0,
  status: false,
  text: '',
  image: '',
  active: false,
});

const classView = computed(() => {
  return [props.active ? '_active' : ''];
});

defineSlots<{
  default?(): void;
}>();
</script>

<template lang="pug">
button.ui-avatar.s-32(:class="classView")
  .ui-avatar-image
    UiImage(v-if="image" :src="image")
  .ui-avatar-content
    slot
      .ui-avatar-text(v-if="!image") {{ text }}
  .ui-badge.flex-center-center.s-20(v-show="badge") {{ badge }}
  .ui-status.s-10.br-10(v-show="status")
</template>

<style lang="scss" scoped>
@import '../../styles/colors';

.ui-avatar {
  position: relative;
  color: $ui-color-icon-default;
  border: none;
  cursor: pointer;
  padding: 0;
  background: none;

  &._active {
    color: $ui-color-text-white;

    .ui-avatar-image {
      background: $ui-color-icon-primary;
    }
  }

  &:hover {
    color: $ui-color-icon-default;

    .ui-avatar-image {
      background: $ui-color-bg-secondary;
    }
  }
}

.ui-avatar-image {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  clip-path: path(
    'M32 16.0114C32 10.1101 30.5361 4.55182 28.5232 2.72194C26.762 1.14367 21.9128 0 16.0114 0C10.0872 0 5.51251 1.02931 3.797 2.44746C1.60114 4.25447 0 10.0872 0 16.0114C0 21.9357 1.14367 26.7848 2.72194 28.5232C4.52895 30.5361 10.0872 32 16.0114 32C21.9128 32 27.8828 30.3302 29.6898 28.0429C31.0164 26.3731 32 21.9128 32 16.0114Z'
  );
}

.ui-avatar-content {
  display: flex;
  position: relative;
  padding: 6px;
}

.ui-avatar-text {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $ui-color-text-violet;
  font-size: 16px;
  line-height: 20px;
}

.ui-badge {
  position: absolute;
  top: -4px;
  left: 20px;
  border-radius: 100px;
  background: $ui-color-icon-notification;
  color: $ui-color-text-white;
  font-size: 12px;
  line-height: 16px;
}

.ui-status {
  position: absolute;
  top: 24px;
  left: 24px;
  background: $ui-color-icon-success;
  border: 1px solid $ui-color-bg-default;
}
</style>
